module.exports = __webpack_public_path__ + "img/Aaliya.39637b7.png";